import React from 'react';
import { Card } from '@/components/ui';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface MetricCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  subValue?: string;
  trend?: {
    value: number;
    direction: 'up' | 'down' | 'neutral';
  };
  color?: string;
}

export function MetricCard({
  icon,
  label,
  value,
  subValue,
  trend,
  color = 'var(--accent-cyan)'
}: MetricCardProps) {
  const TrendIcon = trend?.direction === 'up' ? ArrowUp : 
                    trend?.direction === 'down' ? ArrowDown : Minus;
  
  return (
    <Card
      className="relative overflow-hidden p-6"
    >
      {/* Gradient Border Effect */}
      <div 
        className="absolute inset-0 rounded-lg opacity-50 pointer-events-none"
        style={{
          background: `linear-gradient(135deg, ${color}, var(--accent-magenta))`,
          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
          padding: '2px'
        }}
      />
      
      <div className="relative z-10">
        {/* Header */}
        <div className="flex items-center gap-3 mb-4">
          <div 
            className="w-8 h-8 flex items-center justify-center"
            style={{ color }}
          >
            {icon}
          </div>
          <span className="text-caption text-muted-foreground uppercase">
            {label}
          </span>
        </div>
        
        {/* Value */}
        <div className="mb-3">
          <span className="text-display font-mono font-bold text-foreground">
            {value}
          </span>
          {subValue && (
            <span className="ml-2 text-sm text-muted-foreground">
              {subValue}
            </span>
          )}
        </div>

        {/* Trend */}
        {trend && (
          <div className={cn(
            'flex items-center gap-1 text-sm font-semibold',
            trend.direction === 'up' && 'text-accent-green',
            trend.direction === 'down' && 'text-accent-red',
            trend.direction === 'neutral' && 'text-muted-foreground/70'
          )}>
            <TrendIcon className="w-4 h-4" />
            <span>{Math.abs(trend.value)}%</span>
          </div>
        )}
      </div>
    </Card>
  );
}




